import waitingScreenService from "../../../../../services/waitingScreenService";

import { setIsRemoteParticipantJoined } from "../../../../../reducers/common-reducer";
import { dualStreamEnabled, initialRecordingOff, isSilentObserver, singleUserEnabled } from "../../../../../shared/utility";
import { LogFirebase } from "../../../../../services/firestore";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../../../constants/PublicVariables";
import { setSilentObserverConnect, setSilentUserConnectTheCall } from "../../../../../reducers/silentObserver-reducer";
import { closeSilentObserverPopup } from "../../../../SilentObserver/SilentObserverUtils";
import { CALL_BODY_SCREEN, ENABLED, EXTRACT_TEXT_VIEW, RECORDING } from "../../../../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../../../../constants/DataTrackNotificationConstants";
import { UPLOAD_FILE_DATA_TRACK_STATUS } from "../../../../../constants/UploadFilesConstants";
import {
    handleSendVideoScreenShareDataTrack,
    micCameraPermissionDatatrackSend,
    sendDataTrack,
    sendJoinDataTrack,
    sendMeasurementMsg,
    sendMsgForPointer,
    sendScreenshareStatusToAgent,
    sendStartRecordingMsg,
    sendVideoStatusToAgent,
} from "../../../../../shared/dataTrackFunction";
import { isSilentObserverAvailable } from "../../../../../shared/function";
import { manageShowMeMicrophone, sendVideoQualityDataTrack } from "../../../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import { setParticipantIdentities } from "../../../../../reducers/twilioEvents-reducer";
import { handleReceivedDataTrack } from "../../../DataTrack/allReceiveDataTrack";
import { handleLocationInfoOnJoin } from "../../../../LiveLocation/LocationUtils";
import { getRecordingFeatureFlagValue, showCallRecordingMessage } from "../../../../Recording/RecordingUtils";
import { expandViewEnabled, isLocalUserVideoOn, isvideoenabled } from "../../../Room/roomFunction";
import { STATUS } from "../../../../../constants/LivePointerConstants";
import livePointerService from "../../../../LivePointer/livePointerService";
import markupService from "../../../../../services/MarkupService/markupService";
import extractTextService from "../../../../../services/extractTextService";
import { sendExpandChangeMsg } from "../../../../GalleryView/GalleryViewUtils";
import zoomService from "../../../../../services/zoomService";
import { handleVideoTrackSubscribed } from "./handleVideoTrackSubscribed";
import { handleAudioTrackSubscribedInRoom } from "./handleAudioTrackSubscribedInRoom";
import { setRemoteDataForCallStats } from "../../../../../reducers/callstats-reducer";
import reduxStore from "../../../../../configureEnvStore";
import { checkiOSUserAudio } from "../../../AudioCall/AudioCallUtils";

const handleDataTrackSubscribed = (track, remoteTrackPrublication, participant) => {
    LogFirebase("TwilioEvents", "data_track_subscribed", { identity: participant.identity });
    const { participantIdentities, streamingPartiIdentity, isLocalUserScreenSharing } = reduxStore.getState().twilioEvents;
    reduxStore.dispatch(setRemoteDataForCallStats(true));
    checkiOSUserAudio();
    showCallRecordingMessage(); //shows call is being recorded message if recording is ON

    const silentObserverConnect = reduxStore.getState()?.silentObserver?.silentObserverConnect;
    if (CALL_DATA.isObserver && silentObserverConnect) {
        reduxStore.dispatch(setSilentUserConnectTheCall(true));
        closeSilentObserverPopup();
        reduxStore.dispatch(setSilentObserverConnect(false));
    }

    if (participant.identity != CALL_DATA.localIdentity) {
        // if new user joins and upload files are in progress
        setTimeout(() => {
            const { currentCallBodyScreen } = reduxStore.getState().commonReducer;
            if (currentCallBodyScreen === CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN) {
                const msg = {
                    notification_type: NOTIFICATION_TYPES.UPLOAD_FILE,
                    device_type: GLOBAL_MEETING_DATA.device_type,
                    identity: CALL_DATA.localIdentity,
                    status: UPLOAD_FILE_DATA_TRACK_STATUS.START, // 1 - start, 2 - end, 3 - remainingcount
                };
                sendDataTrack(msg);
            }
        }, 2000);

        if (!singleUserEnabled() && !isSilentObserverAvailable()) {
            manageShowMeMicrophone();
        }
    }

    if (!participantIdentities.includes(participant.identity)) {
        reduxStore.dispatch(setParticipantIdentities([...participantIdentities, participant.identity]));
        handleReceivedDataTrack(track);

        sendJoinDataTrack();

        if (participant.identity.indexOf("_user") > -1) {
            micCameraPermissionDatatrackSend();
            micCameraPermissionDatatrackSend("mic");

            handleLocationInfoOnJoin();
        }

        /* if new participant joins, if annotation is ongoing agent will send notification to start markup with assigned color */
        if (GLOBAL_MEETING_DATA.isAgent) {
            // new joinee cases for Recording
            const { recordingON } = reduxStore.getState().recording;
            if (getRecordingFeatureFlagValue() == RECORDING.INITOFF && recordingON && initialRecordingOff()) {
                sendStartRecordingMsg("2");
            }

            // new joinee cases for expand view
            if (dualStreamEnabled() && expandViewEnabled()) {
                /*
                 * condition is not needed now as we do not stop the video when recording is on
                 * previously we checked that recording and expand view is on, then we do not directly add new user in expand view
                 * first Agent send recoridng start msg and after that we send expand msg
                 */
                LogFirebase("MultiStream", "NewUserWhenExpandOn", CALL_DATA.localIdentity);
                setTimeout(function () {
                    sendExpandChangeMsg(streamingPartiIdentity, "expand", "");
                }, 1500);
            }

            // new joinee cases for OCR
            setTimeout(function () {
                extractTextService.handleNewJoineeForOCR();
                // new joinee cases for Markup
                markupService.handleNewJoineeForMarkup(participant.identity);
            }, 3000);

            // new joinee cases for Live pointer
            if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
                //ocr is on - send disable pointer msg
                const { extractTextInprogress } = reduxStore.getState().extractText;
                if (extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
                    sendMsgForPointer(STATUS.DISABLED);
                }
            }

            // new joinee cases for Auto Live Pointer (single stream only)
            // Send auto pointer status with colors to new participant if pointer is active
            livePointerService.checkLivePointerForNewParticipant();

            // new joinee case for Video Quality
            sendVideoQualityDataTrack();
            // new joinee cases for Measurement
            sendMeasurementMsg();
            // new joinee case for live caption
        }

        if (participant.identity.includes("_user")) {
            const isDualStream = dualStreamEnabled();
            setTimeout(() => {
                if (isDualStream || (!isDualStream && CALL_DATA.localIdentity === streamingPartiIdentity)) {
                    handleSendDataTrackOfVideoScreenShareWhenAgentJoins();
                }
            }, 2000);
        }

        /* if new participant joins, streaming participant will send message for ACK of function status */
        if (CALL_DATA.localIdentity == streamingPartiIdentity) {
            //send new user ack of screen share is ON
            if (isLocalUserScreenSharing) {
                handleSendVideoScreenShareDataTrack("1", "0", "0");
            }

            if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
                const { pointerOn } = reduxStore.getState().livePointer;
                if (pointerOn) {
                    sendMsgForPointer(); //live cursor is ON
                } else {
                    if (isLocalUserScreenSharing && !GLOBAL_MEETING_DATA.isAgent) {
                        //do nothing
                    } else {
                        LogFirebase("dataSubscribed", "in_Streaming_livepointer", streamingPartiIdentity);
                        sendMsgForPointer(STATUS.ENABLED); //agent ss/vdo or guest vdo only
                    }
                }
            }

            if (PublicVariables.featureFlag.SHOWMEZOOM === ENABLED && isvideoenabled()) {
                //send zoom level to new user
                zoomService.sendZoomLevelMsg();
            }
        }
    }
};

const handleSendDataTrackOfVideoScreenShareWhenAgentJoins = () => {
    const { isLocalUserScreenSharing } = reduxStore.getState().twilioEvents;
    if (isLocalUserScreenSharing) {
        sendScreenshareStatusToAgent(ENABLED);
    } else if (isLocalUserVideoOn()) {
        sendVideoStatusToAgent(ENABLED);
    }
};

export const trackSubscribedEvent = ({ track, remoteTrackPrublication, participant }) => {
    if (track) {
        waitingScreenService.showProgressBar(false);
        reduxStore.dispatch(setIsRemoteParticipantJoined(true));
        console.log("trackSubscribedInRoom:- ", track.kind, track);
        LogFirebase("TwilioEvents", "trackSubscribedInRoom", {
            track_details: track.kind,
            participant_details: participant.identity,
        });

        if (track.kind == "audio") {
            handleAudioTrackSubscribedInRoom(track, participant);
        }

        if (track.kind == "video") {
            if (isSilentObserver(participant.identity)) {
                // do nothing
            } else {
                handleVideoTrackSubscribed(track, remoteTrackPrublication, participant);
            }
        }

        if (track.kind == "data") {
            handleDataTrackSubscribed(track, remoteTrackPrublication, participant);
        }
    }
};
